import { useState } from 'react'

import { useAuth } from '@/stores/auth'
import { currentCompanyId } from '@/lib/companyUrl'
import { useToast } from '@/stores/toast'

/** 인증 헤더(토큰 + 현재 창 회사)로 파일을 받아 다운로드시키는 공용 훅.
 *  6개 탭에 복붙돼 있던 fetch+blob+a.download+토스트+로딩상태를 한 곳으로. */
export function useFileDownload() {
  const [downloading, setDownloading] = useState(false)
  const push = useToast((s) => s.push)

  async function download(url: string, filename: string): Promise<void> {
    setDownloading(true)
    try {
      const token = useAuth.getState().token
      const cid = currentCompanyId()
      const res = await fetch(url, {
        headers: {
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
          ...(cid ? { 'X-Company-Id': String(cid) } : {}),
        },
      })
      if (!res.ok) throw new Error(`HTTP ${res.status}`)
      const blob = await res.blob()
      const objUrl = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = objUrl
      a.download = filename
      document.body.appendChild(a)
      a.click()
      a.remove()
      URL.revokeObjectURL(objUrl)
      push('엑셀 다운로드 완료', 'success')
    } catch (e) {
      push(`다운로드 실패: ${e instanceof Error ? e.message : e}`, 'error', 6000)
    } finally {
      setDownloading(false)
    }
  }

  return { downloading, download }
}
